import { render, staticRenderFns } from "./settlement-divider.vue?vue&type=template&id=f34ef378&scoped=true"
import script from "./settlement-divider.vue?vue&type=script&lang=js"
export * from "./settlement-divider.vue?vue&type=script&lang=js"
import style0 from "./settlement-divider.vue?vue&type=style&index=0&id=f34ef378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34ef378",
  null
  
)

export default component.exports